/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DoctorSelectionRequestPatientInfoDto
 */
export interface DoctorSelectionRequestPatientInfoDto {
    /**
     * 
     * @type {string}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'epilepsyDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'firstSeizureDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'historyComment'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'patientBirthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'patientFirstName'?: string;
    /**
     * 
     * @type {number}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'patientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'patientLastName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'patientProductsUsed'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'patientSex'?: DoctorSelectionRequestPatientInfoDtoPatientSexEnum;
    /**
     * 
     * @type {number}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'requestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DoctorSelectionRequestPatientInfoDto
     */
    'responseDeadline'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DoctorSelectionRequestPatientInfoDtoPatientSexEnum {
    Male = 'MALE',
    Female = 'FEMALE'
}


